'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

export default function RightSidebar() {
    const pathname = usePathname();
    const [scrollY, setScrollY] = useState(0);
    const [renderNonce, setRenderNonce] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setRenderNonce((v) => v + 1);
        try {
            (window as any).MarketingNewsletter?.rescan?.();
            (window as any).AutoAds?.init?.();
        } catch {}
    }, [pathname]);

    const stickyTop = Math.max(-28, 24 - scrollY);

    return (
        <aside 
            className="w-full xl:w-[300px] shrink-0 space-y-8 hidden xl:block sticky"
            style={{ top: `${stickyTop}px`, transition: 'top 180ms ease-out' }}
        >
            <div>
                <div key={`nl-${pathname}-${renderNonce}`} data-newsletter-id="cmm0r1twf000uf3l8o9amwl4c"></div>
            </div>

            <div className="rounded-md border border-[var(--color-border)] bg-[var(--bg-elevated)]">
                <div className="h-[250px] w-[300px] rounded-md mx-auto bg-[var(--bg-secondary)] flex items-center justify-center overflow-hidden">
                    <div key={`ad-a-${pathname}-${renderNonce}`} data-ad-placement="cmjiqm6p1000512xot0l3pocy" className="w-full h-full" suppressHydrationWarning={true}></div>
                </div>
            </div>
            
            <div className="rounded-md border border-[var(--color-border)] bg-[var(--bg-elevated)]">
                <div className="h-[250px] w-[300px] rounded-md mx-auto bg-[var(--bg-secondary)] flex items-center justify-center overflow-hidden">
                    <div key={`ad-b-${pathname}-${renderNonce}`} data-ad-placement="cmm0jm5xc000ljg95dfktcxlh" className="w-full h-full" suppressHydrationWarning={true}></div>
                </div>
            </div>
        </aside>
    );
}
